import { useAuth } from "../../context/authContext";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({children}) {
    const {user, loading} = useAuth()

    if(loading) return <h3>Loading...</h3>
    if (!user) return <Navigate to='/'/>
    
    return <>{children}</>
}